import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "lucky-spin-record-popup" }
const _hoisted_2 = { class: "record-popup-title" }
const _hoisted_3 = { class: "record-wrap" }
const _hoisted_4 = { class: "record-header flex" }
const _hoisted_5 = { class: "record-header-item" }
const _hoisted_6 = { class: "record-header-item" }
const _hoisted_7 = { class: "scroll-view" }
const _hoisted_8 = { class: "record-item-detail flex" }
const _hoisted_9 = { class: "record-value" }
const _hoisted_10 = { class: "record-value" }
const _hoisted_11 = { key: 1 }

import { ref, onMounted } from 'vue';
import { queryLuckySpinRecord } from '@/api';


export default {
  __name: 'Record',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);
const dataList = ref([]);
const current = ref(1);
const pageSize = ref(10);

onMounted(() => {
  fetchList();
})

const fetchList = () => {
  queryLuckySpinRecord({
    pageSize: pageSize.value,
    current: current.value,
  }).then(res => {
    dataList.value = dataList.value.concat(res.data || []);
    if (res.total <= res.page * pageSize.value) {
      finished.value = true;
    } else {
      current.value = res.page + 1;
    }
    loading.value = false;
  });
}

const loadData = () => {
  if (refreshing.value) {
    dataList.value = [];
    current.value = 1;
    refreshing.value = false;
  }
  fetchList();
}

const refreshData = () => {
  // 清空列表数据
  finished.value = false;
        
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true;
  loadData();
}

return (_ctx, _cache) => {
  const _component_van_list = _resolveComponent("van-list")
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")
  const _component_PopupForm = _resolveComponent("PopupForm")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PopupForm, {
      displayType: "style2",
      onOnClose: _cache[2] || (_cache[2] = $event => (emit('onClose')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('luckySpin.spinRecord').toUpperCase()), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('label.time').toUpperCase()), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('label.reward').toUpperCase()), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_van_pull_refresh, {
              modelValue: refreshing.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((refreshing).value = $event)),
              onRefresh: refreshData
            }, {
              default: _withCtx(() => [
                (dataList.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_van_list, {
                      key: 0,
                      loading: loading.value,
                      "onUpdate:loading": _cache[0] || (_cache[0] = $event => ((loading).value = $event)),
                      class: "record-list",
                      finished: finished.value,
                      "finished-text": _ctx.$t('common.noMore'),
                      onLoad: loadData
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "record-item",
                            key: item.id
                          }, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$moment(item.createTime * 1000).format('YYYY-MM-DD HH:mm:ss')), 1),
                              _createElementVNode("div", _hoisted_10, _toDisplayString(item.awardName), 1)
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["loading", "finished", "finished-text"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_van_empty, {
                        description: _ctx.$t('common.noData')
                      }, null, 8, ["description"])
                    ]))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

}